import { get } from "../../httpService";

export const getDasaBhukthi = (userId) => get(`/jaadhagams/dasa/${userId}`);

export const retrieveDasas = (data) => get(`/jaadhagams/planet/periods/dasas/${data.userId}`);
export const retrievePutthis = (data) => get(`/jaadhagams/planet/periods/dasas/${data.dasa.planet}/putthis/${data.userId}`);
export const retrieveAndharams = (data) => get(`/jaadhagams/planet/periods/dasas/${data.dasa.planet}/putthis/${data.putthi.planet}/andharams/${data.userId}`);
export const retrieveSootchamams = (data) => get(`/jaadhagams//planet/periods/dasas/${data.dasa.planet}/putthis/${data.putthi.planet}/andharams/${data.andharam.planet}/sootchamams/${data.userId}`);

export const searchDasaByDate = (data, date) => get(`/jaadhagams/planet/periods/dasas/${data.userId}/search/date/${date}`);